import { ethers } from 'ethers';

export const metamaskHomepageUrl = 'https://metamask.io/';

export const metamaskErrorMessage = {
  already_processing: 'Already processing. Click on your metamask extension!',
  not_installed: 'Metamask is not installed!',
};

export const connectMetamaskWallet = async () => {
  if (window.ethereum) {
    try {
      //request user to connect there metamask wallet
      const addressArray = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      return {
        address: addressArray[0],
        error: null,
      };
    } catch (err) {
      if (err.code === 4001) {
        return {
          address: null,
          error: err.message,
        };
      } else {
        return {
          address: null,
          error: metamaskErrorMessage.already_processing,
        };
      }
    }
  } else {
    return {
      address: null,
      error: metamaskErrorMessage.not_installed,
    };
  }
};

export const signMessage = async ({ message }) => {
  try {
    await window.ethereum.send('eth_requestAccounts');
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    await signer.signMessage(message);
    await signer.getAddress();

    return {
      status: 'success',
      message: 'Message Signed by the user.',
    };
  } catch (err) {
    return {
      status: 'error',
      message: 'Signature was not authorized',
    };
  }
};

export const requestConnectWithList = async () => {
  if (window.ethereum) {
    try {
      //request user to connect there metamask wallet
      const addressArray = await window.ethereum.request({
        method: 'wallet_requestPermissions',
        params: [
          {
            eth_accounts: {},
          },
        ],
      });
      return {
        address: addressArray?.[0]?.caveats?.[0]?.value?.[0],
        error: null,
      };
    } catch (err) {
      if (err.code === 4001) {
        return {
          address: null,
          error: err.message,
        };
      } else {
        return {
          address: null,
          error: metamaskErrorMessage.already_processing,
        };
      }
    }
  } else {
    return {
      address: null,
      error: metamaskErrorMessage.not_installed,
    };
  }
};
